/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { IGetHelpInput, IHelp } from '@msdyn365-commerce-modules/order-management';
import * as React from 'react';

export const getOrderDetailsHelp = ({ needHelpLabel, helpLineNumberLabel, contactNumber, helpLineContactAriaLabel }: IGetHelpInput): IHelp => ({
    helpProps: { className: 'ms-order-details__help' },
    needHelpLabel: <p className='ms-order-details__help-title'>{needHelpLabel}</p>,
    helpLineNumberLabel: <span className='ms-order-details__help-label'>{helpLineNumberLabel}</span>,
    contactNumber: (
        <a className='ms-order-details__help-content-number' aria-label={helpLineContactAriaLabel} href={`tel:${contactNumber}`}>
            {contactNumber}
        </a>
    )
});
